import { lazy } from 'react';

export const ApplicationCheckPage = lazy(
  () => import('./ui/ApplicationCheckPage/ApplicationCheckPage'),
);
export const ApplCheckCreateFormStep1 = lazy(
  () => import('./ui/ApplCheckCreateFormStep1/ApplCheckCreateFormStep1'),
);
export const ApplCheckCreateFormStep2 = lazy(
  () => import('./ui/ApplCheckCreateFormStep2/ApplCheckCreateFormStep2'),
);

export const ApplicationCheckDetailsPage = lazy(
  () => import('./ui/ApplicationCheckDetailsPage/ApplicationCheckDetailsPage'),
);

export const ApplCheckLawConclusionPage = lazy(
  () => import('./ui/ApplCheckLawConclusionPage/ApplCheckLawConclusionPage'),
);

export const ApplCheckUnderConclusionPage = lazy(
  () =>
    import('./ui/ApplCheckUnderConclusionPage/ApplCheckUnderConclusionPage'),
);

export const LawyerConclusionPreview = lazy(
  () => import('./ui/LawyerConclusionPreview/LawyerConclusionPreview'),
);
export const UnderwriterConclusionPreview = lazy(
  () =>
    import('./ui/UnderwriterConclusionPreview/UnderwriterConclusionPreview'),
);
